<template>
  <b-navbar-nav>
    <b-nav-text class="proc-text">{{$t('message.init_procedure') | title}}</b-nav-text>
    <b-nav-item to="/general_script/config/time">
      0. {{$t('message.time') | title}} ({{$t('message.optional')}})
    </b-nav-item>
    <b-nav-item to="/general_script/config/network" v-if="initConfig.mode != 'cloud' || canSetCloud">
      <span :class="{current: initConfig.state == 'start'}">
        1. {{$t('message.network') | title}}
      </span>
    </b-nav-item>
    <b-nav-item to="/init/mode" v-if="initConfig.mode != 'cloud' || canSetCloud">
      <span :class="{current: initConfig.state == 'network set'}">
        2. {{$t('message.init_mode') | title}}
      </span>
    </b-nav-item>
    <b-nav-item to="/general_script/config/license" v-if="initConfig.mode != 'cloud' || canSetCloud">
      <span :class="{current: initConfig.state == 'mode set'}">
        3. {{$t('message.script_config_license') | title}}
      </span>
    </b-nav-item>
    <b-nav-item to="/init/agung">
      <span v-if="initConfig.mode != 'cloud' || canSetCloud" :class="{current: initConfig.state == 'license set'}">
        4. {{$t('message.init_agung') | title}}</span>
      <span v-else :class="{current: initConfig.state == 'start'}">
        1. {{$t('message.init_agung') | title}}
      </span>
    </b-nav-item>
    <b-nav-item v-if="initConfig.mode == 'cluster'" to="/general_script/services/reboot_all_cluster_nodes">
      <span :class="{current: initConfig.state == 'db initialized'}">
        5. {{$t('message.script_services_reboot_all_cluster_nodes') | title}}
      </span>
    </b-nav-item>
    <b-nav-item v-else to="/general_script/services/reboot">
      <span v-if="initConfig.mode != 'cloud' || canSetCloud" :class="{current: initConfig.state == 'db initialized'}">
        5. {{$t('message.script_services_reboot') | title}}
      </span>
      <span v-else :class="{current: initConfig.state == 'db initialized'}">
        2. {{$t('message.script_services_reboot') | title}}
      </span>
    </b-nav-item>
  </b-navbar-nav>
</template>

<script>
export default {
  name: 'InitMenu',
  props: {initConfig: Object, canSetCloud: Boolean}
}
</script>

<style scoped>
@import "./../styles/initMenuComponent.css";
</style>
